import { useGetPrototypeQuery } from 'hooks/queries/prototypes/useGetPrototypeQuery';
import { useLocation } from 'react-router-dom';

import DevSandboxSkeleton from 'components/DevSandbox/DevSandboxSkeleton';
import { SEO } from 'components/SEO';

import PrototypePlayground from './PrototypePlayground';

const PrototypeHub = () => {
  const { pathname } = useLocation();
  const hasTabInUrl =
    pathname.includes('browser') ||
    pathname.includes('summary') ||
    pathname.includes('merlin') ||
    pathname.includes('comments') ||
    pathname.includes('explore');
  const tabScreenName = pathname.split('/').pop();
  const solutionUrl = hasTabInUrl
    ? pathname.replace(`/${tabScreenName}`, '')
    : pathname;

  const { data, isPending } = useGetPrototypeQuery({
    solution_url: solutionUrl,
  });

  if (!data || isPending) {
    return <DevSandboxSkeleton loadingText="Loading prototype..." />;
  }

  return (
    <>
      <SEO
        title={`BigDevSoon | ${data.title} Prototype`}
        url={`${process.env.REACT_APP_SITE_URL}prototypes/${data.user.screen_name}/${data.screen_name}`}
        image={data.screenshot_url}
      />
      <PrototypePlayground prototype={data} />
    </>
  );
};

export default PrototypeHub;
